import { useEffect, useState } from "react";
import { portalLogin, portalMe, portalLogout } from "@/utils/portalApi";

export default function PortalLoginPage({ realm = "admin", title = "Portal" }) {
  const [status, setStatus] = useState({ loading: true, user: null, error: "" });
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    portalMe()
      .then((r) => {
        if (!alive) return;
        setStatus({ loading: false, user: r?.user || null, error: "" });
      })
      .catch(() => {
        if (!alive) return;
        setStatus({ loading: false, user: null, error: "" });
      });
    return () => {
      alive = false;
    };
  }, []);

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await portalLogin({ username, password, realm });
      const me = await portalMe();
      setStatus({ loading: false, user: me?.user || null, error: "" });
      setPassword("");
    } catch (err) {
      setStatus((s) => ({ ...s, error: err?.message || "Login failed" }));
    } finally {
      setBusy(false);
    }
  }

  async function onLogout() {
    setBusy(true);
    try {
      await portalLogout();
      setStatus({ loading: false, user: null, error: "" });
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#f7f8fa] text-[#0b1220] flex flex-col items-center justify-center px-4 py-12 antialiased">
      <div className="w-full max-w-md">
        <h1 className="text-2xl font-bold text-[#0b378c] tracking-tight">{title}</h1>
        <p className="mt-2 text-sm text-slate-600">
          Autentificare ({realm}).
        </p>

        {status.loading ? (
          <p className="mt-6 text-sm text-slate-600">Loading…</p>
        ) : status.user ? (
          <div className="mt-6 rounded-xl border border-slate-200 bg-white p-4">
            <p className="text-sm">
              Logged in as <span className="font-semibold">{status.user.username}</span> ({status.user.realm})
            </p>
            <button
              type="button"
              onClick={onLogout}
              disabled={busy}
              className="mt-4 w-full rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white disabled:opacity-50"
            >
              Logout
            </button>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="mt-6 rounded-xl border border-slate-200 bg-white p-4 space-y-3">
            <div>
              <label className="block text-xs font-semibold text-slate-600">Username</label>
              <input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm"
                autoComplete="username"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-slate-600">Password</label>
              <input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm"
                type="password"
                autoComplete="current-password"
              />
            </div>
            {status.error ? (
              <p className="text-sm text-red-700">{status.error}</p>
            ) : null}
            <button
              type="submit"
              disabled={busy || !username || !password}
              className="w-full rounded-lg bg-[#0b378c] px-4 py-2 text-sm font-semibold text-white disabled:opacity-50"
            >
              Login
            </button>
          </form>
        )}

        <a href="/app" className="mt-6 inline-block text-sm text-slate-600 underline underline-offset-4">
          Înapoi la hub
        </a>
      </div>
    </div>
  );
}

